module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAANBAMAAABfi4NQAAAAG1BMVEUAAACZmZmZmZmampqXl5eZmZmZmZmXl5eZmZkqSj4PAAAACHRSTlMAgKBgYHBQQBxvXWcAAABFSURBVAjXYwCDYAY4YOoQgLM1OhoRwh1ACZiwEEyCCcjQgEiAaBAfKgwRgJAQESgBFfIAYojSZgYPmDUSzQxsBVA2iwEANAsShr1BAccAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ../src/component/post-item/img/icon-arrow-top.png
// module id = 838
// module chunks = 0 1